<template>
  <div class="avatar" :style="{ width: size, 'border-radius': radius }">
    <img
      v-if="imgSrc"
      :src="imgSrc"
      :style="{ 'object-fit': 'cover' }" />
    <svg
      v-if="!imgSrc"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none">
      <rect
        width="100%"
        height="100%"
        :fill="initialsColor" />
      <text
        x="50%"
        y="50%"
        dominant-baseline="middle"
        text-anchor="middle"
        font-size="42"
        dy="5"
        fill="rgba(255,255,255,0.6)">{{ initials }}</text>
    </svg>
  </div>
</template>

<script>
import config from '@/config'

export default {
  name: 'Avatar',
  props: {
    src: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: '44px'
    },
    radius: {
      type: String,
      default: '22px'
    },
    resize: {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
    imgSrc () {
      if (this.resize && this.src) {
        return `${config.modfile_url}image/520x520x1/${encodeURIComponent(this.src)}`
      } else {
        return this.src
      }
    },
    initials () {
      if (this.name) {
        const name = this.name.replace(/[^0-9a-z\u00C0-\u017F]/gi, '').replace(/\s+/g, ' ').trim()
        return name.slice(0, 2).toUpperCase()
      }
      return 'ND'
    },
    initialsColor () {
      const initials = this.initials
      // return this.generateGrayColor(initials, 2.2)
      return this.generateColor(initials, 65, 50)

      /*
      let hash = 0
      for (let i = 0; i < initials.length; i++) {
        hash = initials.charCodeAt(i) + ((hash << 5) - hash)
      }

      let color = '#'
      for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xFF
        // Ajuste o valor para ser, pelo menos, 128
        value = Math.max(value, 150)
        color += ('00' + value.toString(16)).substr(-2)
      }

      return color
      */
    }
  },
  created () {
  },
  methods: {
    generateColor (str, brightness, saturation) {
      str = str || 'AA'
      const hash = str.split('').reduce((hash, char) => {
        let code = char.charCodeAt(0)
        return (hash << 5) - hash + code
      }, 0)

      let hue = Math.abs(hash) % 360
      brightness = Math.max(0, Math.min(100, brightness))
      saturation = Math.max(0, Math.min(100, saturation))

      return `hsl(${hue}, ${saturation}%, ${brightness}%)`
    },
    generateGrayColor (inputString, intensity) {
      // Verificar se a string tem a quantidade correta de caracteres
      if (!inputString || inputString.length !== 2) {
        inputString = 'AA'
      }

      // Converter os caracteres para números decimais
      const num1 = inputString.charCodeAt(0)
      const num2 = inputString.charCodeAt(1)

      // Calcular a média dos dois números
      let avg = Math.round((num1 + num2) / 2)

      // Limitar a média ao intervalo 0-255
      if (avg > 255) {
        avg = 255
      } else if (avg < 0) {
        avg = 0
      }

      // Aplicar a intensidade
      let intenseValue = Math.round(avg * intensity)
      if (intenseValue > 255) {
        intenseValue = 255
      } else if (intenseValue < 0) {
        intenseValue = 0
      }

      // Converter a intensidade para um valor hexadecimal
      let hex = intenseValue.toString(16)

      // Garantir que o valor hexadecimal tenha dois dígitos
      if (hex.length < 2) {
        hex = '0' + hex
      }

      // Criar a cor em tons de cinza
      const color = '#' + hex + hex + hex

      return color
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.avatar {
  border-radius: 22px;
  margin: 0;
  position: relative;
  overflow: hidden;
}

.avatar::before {
  content: "";
  display: block;
  padding-top: 100%;
  /* aspect ratio 1:1 (altura igual a largura) */
}

.avatar>img,
.avatar>svg {
  display: block;
  width: 100%;
  height: 100%;
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Parts/Avatar.vue